<template>
<div class="page-container-content tabgroup">
  <el-tabs v-model="activeTab">
    <el-tab-pane :label="tabs.summary.label" :name="tabs.summary.name">
      <w-domain-summary-view :active="tabs.summary.active"/>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import { find, isEmpty } from 'lodash';
import TabMixin from '@/mixins/apm/tab';
import WDomainSummaryView from './components/DomainSummaryView';

export default {
  name: 'WInstanceDomain',
  mixins: [TabMixin],
  components: {
    WDomainSummaryView,
  },
  data() {
    return {
      activeTab: null,
      tabs: {
        summary: {
          name: 'summary',
          label: '요약',
          active: false,
          default: true,
        },
      },
    };
  },
  computed: {
    /**
     * 기존 유지 탭이 없다면 default탭으로 현재 탭 변경
     * @return {[type]} [description]
     * @author jda
     */
    apmActiveTab() {
      const tabs = this.tabs;
      const currentTabName = this.$store.state.apm.mainActiveTab;
      const currentTab = tabs[currentTabName];
      return isEmpty(currentTab) ? find(tabs, 'default').name : currentTab.name;
    },
  },
  watch: {
    apmActiveTab: {
      immediate: true,
      handler(tabName) {
        this.activeTab = tabName;
      },
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/apm/instance/domain/index.vue